import { createFileRoute } from '@tanstack/react-router';
import { ChainDetailPage } from '@/pages/super-admin/chain-detail/ChainDetailPage';
import { z } from 'zod';

const chainDetailSearchSchema = z.object({
	tab: z.enum(['overview', 'modules', 'caps', 'analytics']).optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/super-admin/chains/$parentCompanyId')({
	component: ChainDetailPage,
	validateSearch: chainDetailSearchSchema,
});
